import { Component, Input, OnInit } from '@angular/core';
import { Utility } from 'src/app/shared/utility/utility';
@Component({
  selector: 'app-icon-warning',
  templateUrl: './icon-warning.component.html',
  styleUrls: ['./icon-warning.component.scss']
})
export class IconWarningComponent implements OnInit {
  @Input() icon: string;
  constructor(public util: Utility) { }

  ngOnInit(): void {
    if (!this.util.isNullOrEmpty(this.icon)) {
      this.icon = this.icon.trim();
    }
  }

}
